











































import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';

export default {
  name: 'uOttawa1321Prelab2Q2',
  components: {
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    const browserLanguage = navigator.language.split('-')[0]; // Extract the language code
    return {
      inputs: {
        impuritiesEffectOnMP: null,
        language: browserLanguage === 'fr' ? 'fr' : 'en', // Set the initial language based on browser preference
      },
      options: [
        {text: 'They do not change the observed value', value: 'noChange'},
        {text: 'They increase the observed value', value: 'increase'},
        {text: 'They decrease the observed value', value: 'decrease'},
      ],
      optionsFr: [
        {text: 'Elles ne changent pas la valeur observée', value: 'noChangeFr'},
        {text: 'Elles augmentent la valeur observée', value: 'increaseFr'},
        {text: 'Elles diminuent la valeur observée', value: 'decrease'},
      ],
    };
  },
};
